/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StammdatenInputs */

const en__field_stammdaten = /** @type {(inputs: _Field_StammdatenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institution specific user data`)
};

const de__field_stammdaten = /** @type {(inputs: _Field_StammdatenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institutionsspezifische Daten`)
};

/**
* | output |
* | --- |
* | "Institution specific user data" |
*
* @param {_Field_StammdatenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_stammdaten = /** @type {((inputs?: _Field_StammdatenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StammdatenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_stammdaten(inputs)
	return de__field_stammdaten(inputs)
});